import ConfirmDialog from './ConfirmDialog.jsx';

export {
  ConfirmDialog
};


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/dialog/index.js